import * as React from 'react';
import { useAccountPositionGesEstimDExRate } from '../../hooks';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';

export const AccountsPositionsGesEstimDExrate = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionGesEstimDExRate();
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={{
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      }}
    />
  );
};
